<!-- eslint-disable no-unused-vars -->
<template>
  <div>
    <Header/>
    <Scroll/>
    <div class="hp_productWrap">
      <div class="hp_productMain_contentWrap">
        <!-- hot키워드 -->
        <div class="hp_productMain_contentSidebar hp_MobNonePcBlock">
          <div class="hp_productMain_contentKeywordBox">
            <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
            <div class="hp_productMain_contentKeyword_tagBox">
              <p
                v-for="item in statusData.hotKeywordData"
                :key="item.hot_keyword_ID"
              >
                <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                  #{{ item.hot_keyword_name }}
                </a>
              </p>
            </div>
          </div>
        </div>

        <!-- 실제 상세 예약 내역 : 이거 좌우 메뉴라서 여기서부터 예약상세내역 나오는 것임 -->
        <div class="hp_reservInfoWrap">
          <div class="hp_reservInfo_TopTit">
            <h3>여행예약정보</h3>
          </div>

          <!-- 카드결제 성공 페이지 -->
          <div v-if="this.$route.query.reservation_payment_method === '1' && statusData.reservationData.length !== 0">
            <div class="hp_reservInfo_tit">
              <h5>결제가 성공적으로 <span>완료</span>되었습니다.</h5>
            </div>

            <div class="hp_reservationBox"> <!-- 카드 첫번째 : 여행상품정보 -->
              <div class="hp_reservationBoxTit">
                <h5>예약상품정보</h5>
              </div>
              <table class="hp_reservIB" cellpadding="0" cellspacing="0" summary="상품정보">
                <caption>예약상품정보</caption>
                <colgroup>
                  <col width="25%">
                  <col width="*">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row" class="hp_reservIB_tit hp_reservIB_moNone">상품명</th>
                    <td class="info_titText">{{statusData.reservationData.travel_product_name}}</td>
                  </tr>
                  <tr>
                    <th scope="row" class="hp_reservIB_tit hp_reservIB_moNone">여행기간</th>
                    <td>
                      <div class="info_titDate">
                        <ul>
                          <li class="info_titDate_ico">출발일</li>
                          <li>{{statusData.reservationData.schedule_start_day}}</li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hp_reservationBox"> <!-- 카드 두번째 : 예약자 정보 -->
              <div class="hp_reservationBoxTit">
                <h5>예약자정보</h5>
              </div>
              <table class="hp_reservBox" cellpadding="0" cellspacing="0" summary="예약자정보">
                <caption>예약자정보</caption>
                <colgroup>
                  <col width="25%">
                  <col width="*">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">예약자명</th>
                    <td>{{statusData.reservationData.reservation_customer_name}}</td>
                  </tr>
                  <tr>
                    <th scope="row">휴대폰번호</th>
                    <td>{{statusData.reservationData.reservation_customer_phone_number}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hp_reservationBox"> <!-- 카드 세번째 : 상세예약정보 -->
              <div class="hp_reservationBoxTit">
                <h5>상세예약정보</h5>
              </div>
              <table class="hp_reservBox" cellpadding="0" cellspacing="0" summary="상세예약정보">
                <caption>상세예약정보</caption>
                <colgroup>
                  <col width="25%">
                  <col width="*">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">여행인원</th>
                    <td>대인 {{statusData.reservationData.reservation_number_count}}명, 소인 {{statusData.reservationData.reservation_number_count_child}}명</td>
                  </tr>
                  <tr>
                    <th scope="row">요청사항</th>
                    <td>{{statusData.reservationData.reservation_request}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hp_reservationBox"> <!-- 카드 네번째 : 결제정보 -->
              <div class="hp_reservationBoxTit">
                <h5>결제정보</h5>
              </div>
              <table class="hp_reservBox" cellpadding="0" cellspacing="0" summary="결제정보">
                <caption>결제정보</caption>
                <colgroup>
                  <col width="25%">
                  <col width="*">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">결제방식</th>
                    <td>카드</td>
                  </tr>
                  <tr>
                    <th scope="row">금액</th>
                    <td><span class="hp_reserveInfo_price">{{statusData.reservationData.reservation_payment_amount.toLocaleString()}}</span>원</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <button class="hp_reservInfoBtn" @click="goToMyPage">목록으로</button>
          </div>

          <!-- 무통장 입금 성공 페이지 -->
          <div class="hp_reservInfoBox" v-if="this.$route.query.reservation_payment_method === '0' && statusData.reservationData.length !== 0">
            <div class="hp_reservInfo_tit">
              <h5>무통장 입금 요청이 <span>완료</span>되었습니다.</h5>
              <p>입금상태 : {{statusData.reservationData.reservation_pay_status_name}}</p>
            </div>

            <div class="hp_reservationBox"> <!-- 무통장 첫번째 : 여행상품정보 -->
              <div class="hp_reservationBoxTit">
                <h5>예약상품정보</h5>
              </div>
              <table class="hp_reservIB" cellpadding="0" cellspacing="0" summary="상품정보">
                <caption>예약상품정보</caption>
                <colgroup>
                  <col width="25%">
                  <col width="*">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row" class="hp_reservIB_tit hp_reservIB_moNone">상품명</th>
                    <td class="info_titText">{{statusData.reservationData.travel_product_name}}</td>
                  </tr>
                  <tr>
                  <th scope="row" class="hp_reservIB_tit hp_reservIB_moNone">여행기간</th>
                  <td>
                    <div class="info_titDate">
                      <ul>
                        <li class="info_titDate_ico">출발일</li>
                        <li>{{statusData.reservationData.schedule_start_day}}</li>
                      </ul>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="hp_reservationBox"> <!-- 무통장 두번째 : 예약자 정보 -->
              <div class="hp_reservationBoxTit">
                <h5>예약자정보</h5>
              </div>
              <table class="hp_reservBox" cellpadding="0" cellspacing="0" summary="예약자정보">
                <caption>예약자정보</caption>
                <colgroup>
                  <col width="25%">
                  <col width="*">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">예약자명</th>
                    <td>{{statusData.reservationData.reservation_customer_name}}</td>
                  </tr>
                  <tr>
                    <th scope="row">휴대폰번호</th>
                    <td>{{statusData.reservationData.reservation_customer_phone_number}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hp_reservationBox"> <!-- 무통장 세번째 : 상세예약정보 -->
              <div class="hp_reservationBoxTit">
                <h5>상세예약정보</h5>
              </div>
              <table class="hp_reservBox" cellpadding="0" cellspacing="0" summary="상세예약정보">
                <caption>상세예약정보</caption>
                <colgroup>
                  <col width="25%">
                  <col width="*">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">여행인원</th>
                    <td>대인 {{statusData.reservationData.reservation_number_count}}명, 소인 {{statusData.reservationData.reservation_number_count_child}}명</td>
                  </tr>
                  <tr>
                    <th scope="row">요청사항</th>
                    <td>{{statusData.reservationData.reservation_request}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hp_reservationBox"> <!-- 무통장 네번째 : 결제정보 -->
              <div class="hp_reservationBoxTit">
                <h5>결제정보</h5>
              </div>
              <table class="hp_reservBox" cellpadding="0" cellspacing="0" summary="결제정보">
                <caption>결제정보</caption>
                <colgroup>
                  <col width="25%">
                  <col width="*">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">입금자명</th>
                    <td>{{statusData.reservationData.reservation_depositor_name}}</td>
                  </tr>
                  <tr>
                    <th scope="row">결제방식</th>
                    <td>
                      무통장 입금
                      <div class="hp_paymentBankCopy" @click="copyToClipboard">
                        입금계좌안내
                        <p>{{ statusData.accountInfo }}</p>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">입금상태</th>
                    <td>{{statusData.reservationData.reservation_pay_status_name}}</td>
                  </tr>
                  <tr>
                    <th scope="row">현금영수증</th>
                    <td>{{statusData.reservationData.reservation_cash_receipt_request}}</td>
                  </tr>
                  <tr>
                    <th scope="row">금액</th>
                    <td><span class="hp_reserveInfo_price">{{statusData.reservationData.reservation_expected_payment_amount.toLocaleString()}}</span>원</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="hp_optionBox_totalPrePrice hp_reservInfo_totalPrice">
              <span>입금 금액 : </span>
              <span>{{statusData.reservationData.reservation_expected_payment_amount.toLocaleString()}}</span>원
            </div>

            <div class="hp_reservInfo_text">
              * 입금 후 02-3273-3311 또는 02-3273-4311로 문의 바랍니다.
            </div>

            <button class="hp_reservInfoBtn" @click="goToMyPage">목록으로</button>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>

</template>

<!-- eslint-disable camelcase -->
<script>
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import { ref } from 'vue'
import {
  get_reservation_one,
  get_hot_keyword_top10
} from '../../ETC/Axios.vue'

export default {
  name: 'ReservationSuccess',
  components: {
    Header,
    Footer,
    Scroll
  },
  setup () {
    return {
      statusData: ref({
        reservationData: [],
        hotKeywordData: [],
        accountInfo: '(주)행복을주는사람들 / 우리은행 1005-303-875864'
      })
    }
  },
  methods: {
    copyToClipboard () {
      const textarea = document.createElement('textarea')
      textarea.textContent = this.statusData.accountInfo
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      textarea.remove()
      alert('클립보드에 복사되었습니다.')
    },
    goToMyPage () {
      const { reservation_customer_name, reservation_customer_phone_number } = this.statusData.reservationData
      const myID = 2

      this.$router.push({
        path: '/My',
        query: {
          myID,
          reservation_customer_name,
          reservation_customer_phone_number
        }
      })
    }
  },
  mounted () {
    get_reservation_one(this.$route.query.reservation_ID).then(result => {
      this.statusData.reservationData = result[0]
    })
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Reservation/ReservationSuccess.vue